<div class="container stage bg-white main_container pt-2">
    <div class="row justify-content-center">
        <div class="col-md-12 col-lg-8">
            <gol-edit-security-questions [requirePassword]="false"></gol-edit-security-questions>
        </div>
    </div>
</div>